export default __webpack_public_path__ + "static/media/pantry2-before2-1920w.936c676e.png";